import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ElementSchemaRegistry } from '@angular/compiler';


@Component({
  selector: 'clock-chart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './clock-chart.component.html',
  styleUrls: [
    './clock-chart.component.scss'
  ]
})

export class ClockChartComponent implements OnInit {


  @Input('percents') percentsFromInput;
  @Input('maxHeight') maxHeight;

  percents: string | number;
  previousPercents: string | number;
  strokeDash = "";
  strokeDashBase = "";
  strokeDashPrevious = "";

  center = 250;
  r;
  rPrevious;
  strokeWidth;
  strokeWidthPrevious;
  strokeWidthP = 0.1;
  strokeWidthPreviousP = 0.03;

  percentsDiff = 0;
  status = 0;


  constructor(public chDet: ChangeDetectorRef) {
    this.strokeWidth = Math.ceil(this.center * this.strokeWidthP);
    this.strokeWidthPrevious = Math.ceil(this.center * this.strokeWidthPreviousP);
    this.r = this.center - this.strokeWidth;
  }


  ngOnInit() {


    if (this.percentsFromInput < 0) {
      this.percents = 0;
    } else if (this.percentsFromInput > 100) {
      this.percents = 100;
    } else {
      this.percents = this.percentsFromInput;
    }

    var dash = 2 * this.r * Math.PI / 360 * (<number>this.percents / 100) * 360;
    var dashSpace = 2 * this.r * Math.PI - dash;


    if (this.percentsFromInput < 50) {
      this.status = 0;
    } else if (this.percentsFromInput < 80) {
      this.status = -1;
    } else {
      this.status = 1;
    }

    this.strokeDash = dash + " " + dashSpace;

  }



}



// WEBPACK FOOTER //
// ./src/app/components/chunks/clock-chart/clock-chart.component.ts